// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_Rating = require("../../../shared/src/types/CommonTypes_Rating.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

function BrowserComponents_Rating$Star(Props) {
  var isEditable = Props.isEditable;
  var rating = Props.rating;
  var setRating = Props.setRating;
  var starRating = Props.starRating;
  return React.createElement(BrowserComponents_Button.Icon.make, {
              disabled: !isEditable,
              icon: {
                TAG: /* Small */1,
                _0: {
                  TAG: /* Shift */6,
                  _0: Relude_Option.fold(true, Curry._1(CommonTypes_Rating.greaterThan, starRating), rating) ? /* Star */20 : /* StarFilled */21
                }
              },
              iconColor: isEditable ? ({
                    TAG: /* Teal */6,
                    _0: /* Medium */2
                  }) : ({
                    TAG: /* Grey */2,
                    _0: /* Dark */1
                  }),
              onClick: (function (param) {
                  return Curry._1(setRating, starRating);
                }),
              size: /* Small */1
            });
}

var Star = {
  make: BrowserComponents_Rating$Star
};

function BrowserComponents_Rating$Stateless(Props) {
  var className = Props.className;
  var isEditableOpt = Props.isEditable;
  var rating = Props.rating;
  var setRating = Props.setRating;
  var isEditable = isEditableOpt !== undefined ? isEditableOpt : false;
  var tmp = {
    children: Curry._2(Relude_Array.map, (function (starRating) {
            return React.createElement(BrowserComponents_Rating$Star, {
                        isEditable: isEditable,
                        rating: rating,
                        setRating: setRating,
                        starRating: starRating,
                        key: CommonTypes_Rating.toString(starRating)
                      });
          }), Relude_List.toArray(CommonTypes_Rating.list))
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_FlexRow.make, tmp);
}

var Stateless = {
  make: BrowserComponents_Rating$Stateless
};

function BrowserComponents_Rating(Props) {
  var className = Props.className;
  var isEditableOpt = Props.isEditable;
  var onRate = Props.onRate;
  var rating = Props.rating;
  var isEditable = isEditableOpt !== undefined ? isEditableOpt : false;
  var match = ReactIO.useState(function (param) {
        return rating;
      });
  var setRating = match[1];
  var setRating$1 = function (newRating) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(onRate, newRating);
                }), Curry._1(setRating, Relude_Option.some(newRating)));
  };
  var tmp = {
    isEditable: isEditable,
    rating: match[0],
    setRating: setRating$1
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_Rating$Stateless, tmp);
}

var StyleTypes;

var Icon;

var make = BrowserComponents_Rating;

exports.StyleTypes = StyleTypes;
exports.Icon = Icon;
exports.Star = Star;
exports.Stateless = Stateless;
exports.make = make;
/* react Not a pure module */
